// extracted by mini-css-extract-plugin
export default {"avatar":"_3bFE","avatarCol":"_1fdf","inboxText":"_3EMM","smartAvatar":"_1fwC","lastMessage":"_3mXs","name":"_1HnC","time":"_2A3i","inboxItem":"_2GtW"};